import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { showModal } from "../statusModal/statusModal";
import {
  deleteUserAPI,
  fetchPaginatedUsersAPI,
  updateUserAPI,
} from "./usersAPI";

const initialState = {
  list: [],
  fetchStatus: "idle",
  updateStatus: "idle",
  deleteStatus: "idle",
  currentPage: 1,
  totalPages: 1,
  pageLimit: 10,
  error: null,
};

const mergeUpdatedUser = (user, updatedUser) => {
  if (user._id !== updatedUser._id) {
    return user;
  }

  return {
    ...user,
    ...updatedUser,
  };
};

export const fetchPaginatedUsers = createAsyncThunk(
  "users/fetchPaginatedUsers",
  async ({ page }, { dispatch, getState, rejectWithValue }) => {
    try {
      const { users } = getState();
      const limit = users.pageLimit;

      const data = await fetchPaginatedUsersAPI(page, limit);
      dispatch(
        showModal({
          message: "تم جلب بيانات اللاعبين بنجاح",
          status: "success",
        })
      );

      return data;
    } catch (error) {
      dispatch(
        showModal({ message: "حصل خطأ اثناء جلب البيانات", status: "error" })
      );
      return rejectWithValue(
        error.response?.data?.message || "Failed to fetch admins"
      );
    }
  }
);

export const deleteUser = createAsyncThunk(
  "users/deleteUser",
  async (id, { dispatch, rejectWithValue }) => {
    try {
      const data = await deleteUserAPI(id);
      dispatch(
        showModal({
          message: `تم حذف ${data.data.name} بنجاح`,
          status: "success",
        })
      );
      return data.data._id;
    } catch (error) {
      dispatch(
        showModal({ message: "حصل خطأ اثناء حذف اللاعب", status: "error" })
      );
      return rejectWithValue(
        error.response?.data?.message || "Failed to delete admin"
      );
    }
  }
);

export const updateUser = createAsyncThunk(
  "users/updateUser",
  async ({ userId, userData }, { dispatch, rejectWithValue }) => {
    try {
      const data = await updateUserAPI(userId, userData);

      dispatch(
        showModal({
          message: `تم التعديل على اللاعب بنجاح`,
          status: "success",
        })
      );
      return data.data;
    } catch (error) {
      console.log(error);
      dispatch(
        showModal({
          message: "حصل خطأ اثناء التحديث على اللاعب",
          status: "error",
        })
      );
      return rejectWithValue(
        error.response?.data?.message || "Failed to delete admins"
      );
    }
  }
);

const usersSlice = createSlice({
  name: "users",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchPaginatedUsers.pending, (state) => {
        state.fetchStatus = "loading";
        state.error = null;
      })
      .addCase(fetchPaginatedUsers.fulfilled, (state, action) => {
        const newData = action.payload.data.data.filter(
          (item) => !state.list.find((existing) => existing._id === item._id)
        );
        state.fetchStatus = "succeeded";
        state.list = [...state.list, ...newData];
        state.currentPage = action.payload.data.page;
        state.totalPages = action.payload.data.totalPages;
      })
      .addCase(fetchPaginatedUsers.rejected, (state, action) => {
        state.fetchStatus = "failed";
        state.error = action.payload.error;
      })
      .addCase(deleteUser.pending, (state) => {
        state.deleteStatus = "loading";
        state.error = null;
      })
      .addCase(deleteUser.fulfilled, (state, action) => {
        state.deleteStatus = "succeeded";
        state.list = state.list.filter(({ _id }) => _id !== action.payload);
      })
      .addCase(deleteUser.rejected, (state, action) => {
        state.deleteStatus = "failed";
        state.error = action.payload.error;
      })
      .addCase(updateUser.pending, (state) => {
        state.updateStatus = "loading";
        state.error = null;
      })
      .addCase(updateUser.fulfilled, (state, action) => {
        state.updateStatus = "succeeded";
        state.list = state.list.map((user) =>
          mergeUpdatedUser(user, action.payload)
        );
      })
      .addCase(updateUser.rejected, (state, action) => {
        state.updateStatus = "failed";
        state.error = action.payload.error;
      });
  },
});

export default usersSlice.reducer;
